import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLayoutMarkings = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.30775 17.5C3.80258 17.5 3.375 17.325 3.025 16.975C2.675 16.625 2.5 16.1974 2.5 15.6923V8.30775C2.5 7.80258 2.675 7.375 3.025 7.025C3.375 6.675 3.80258 6.5 4.30775 6.5H19.6923C20.1974 6.5 20.625 6.675 20.975 7.025C21.325 7.375 21.5 7.80258 21.5 8.30775V15.6923C21.5 16.1974 21.325 16.625 20.975 16.975C20.625 17.325 20.1974 17.5 19.6923 17.5H4.30775ZM4.30775 16H19.6923C19.7693 16 19.8398 15.9679 19.9038 15.9038C19.9679 15.8398 20 15.7692 20 15.6923V8.30775C20 8.23075 19.9679 8.16025 19.9038 8.09625C19.8398 8.03208 19.7693 8 19.6923 8H16.75V11.6152H15.25V8H12.75V11.6152H11.25V8H8.75V11.6152H7.25V8H4.30775C4.23075 8 4.16025 8.03208 4.09625 8.09625C4.03208 8.16025 4 8.23075 4 8.30775V15.6923C4 15.7692 4.03208 15.8398 4.09625 15.9038C4.16025 15.9679 4.23075 16 4.30775 16Z",
		fill: "currentColor"
	})
});
export default SvgLayoutMarkings;
